// extracted by mini-css-extract-plugin
module.exports = {"label":"LineToEdit_label__kRu7n"};